import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { CommonLoaderComponent } from 'src/app/shared/components/common-loader/common-loader.component';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { ExportacaoService } from './service/exportacao.service';

@Component({
  selector: 'app-bloco-exportacao',
  imports: [CommonModule, CommonLoaderComponent, MatIconModule],
  standalone: true,
  templateUrl: './bloco-exportacao.component.html',
  styleUrls: ['./bloco-exportacao.component.scss'],
})
export class BlocoExportacaoComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  userId: string;
  companyId: string;
  restrictionKey: string;
  exportWork: boolean;
  clientTypeID: number;
  exportDate: any;

  isLoading: boolean = false;

  imobiliario: boolean = false;
  industrial: boolean = true;

  exportacaoImobiliario: any[] = [];
  exportacaoIndustrial: any;

  _errorHandleService = inject(ErrorHandleService);
  _exportacaoService = inject(ExportacaoService);
  private readonly authService = inject(AuthService);

  private subscriptions: Subscription = new Subscription();

  constructor() {
    this.companyId = this.authService.companyID;
    this.restrictionKey = this.authService.restrictionKey;
    this.userId = this.authService.userID;
  }

  ngOnInit() {
    this.getDadosUsuario();
  }

  getDadosUsuario() {
    let companyId = this.authService.companyID,
      restrictionKey = this.authService.restrictionKey,
      usuarioId = this.authService.userID;
    this.subscriptions.add(
      this._exportacaoService
        .dadosUsuario(companyId, restrictionKey, usuarioId)
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.exportWork = response.data.exportWork;
              this.clientTypeID = response.data.clientTypeID;

              this.dadosExportacaoImobiliario();
              this.dadosExportacaoIndustrial();
            } else {
              this._errorHandleService.throwConsoleError(response);
            }
          },
        }),
    );
  }

  dadosExportacaoImobiliario() {
    this.subscriptions.add(
      this._exportacaoService
        .infoExportacao(this.imobiliario, this.clientTypeID)
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.exportacaoImobiliario = response.data;

              this.exportacaoImobiliario = this.exportacaoImobiliario.map(
                (item) => ({
                  ...item,
                  formattedDate: item.date.slice(0, 10),
                }),
              );
            } else {
              this._errorHandleService.throwConsoleError(response);
            }
          },
        }),
    );
  }

  onDateChangeImobiliario(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;

    if (selectElement && selectElement.value) {
      const selectedDate = selectElement.value;
      this.exportDate = selectedDate.slice(0, 10);
      this.isLoading = true;

      this._exportacaoService
        .downloadExportDate(
          this.userId,
          this.imobiliario,
          this.exportDate,
          this.clientTypeID,
        )
        .subscribe({
          next: (response: Blob) => {
            this.isLoading = false;
            saveAs(response, `RelatorioObras_${this.exportDate}.xlsx`);
          },
          error: (err) => {
            this.isLoading = false;
            console.error('Erro ao baixar o arquivo:', err);
            this._errorHandleService.throwConsoleError(err);
          },
        });
    }
  }

  onDateChangeIndustrial(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;

    if (selectElement && selectElement.value) {
      const selectedDate = selectElement.value;
      this.exportDate = selectedDate.slice(0, 10);

      this.isLoading = true;

      this._exportacaoService
        .downloadExportDate(
          this.userId,
          this.industrial,
          this.exportDate,
          this.clientTypeID,
        )
        .subscribe({
          next: (response: Blob) => {
            this.isLoading = false;
            saveAs(response, `RelatorioObras_${this.exportDate}.xlsx`);
          },
          error: (err) => {
            this.isLoading = false;
            console.error('Erro ao baixar o arquivo:', err);
            this._errorHandleService.throwConsoleError(err);
          },
        });
    }
  }
  exportImobiliario(): void {
    const exportDate = this.exportDate || new Date().toISOString().slice(0, 10);
    this._exportacaoService
      .downloadExport(this.userId, this.imobiliario, this.clientTypeID)
      .subscribe({
        next: (response: Blob) => {
          saveAs(response, `RelatorioObras_${exportDate}.xlsx`);
        },

        error: (err) => {
          console.error('Erro ao baixar o arquivo:', err);

          if (err.status === 400) {
            if (err.error instanceof Blob) {
              err.error
                .text()
                .then((text: string) => {
                  try {
                    const errorMessages = JSON.parse(text);
                    if (
                      Array.isArray(errorMessages) &&
                      errorMessages.length > 0
                    ) {
                      alert(errorMessages[0]);
                    } else {
                      alert('Erro desconhecido.');
                    }
                  } catch (e) {
                    console.error('Erro ao processar a resposta JSON:', e);
                    alert('Erro ao processar a resposta.');
                  }
                })
                .catch((e) => {
                  console.error('Erro ao ler o Blob:', e);
                  alert('Erro ao processar a resposta do servidor.');
                });
            }
          } else {
            this._errorHandleService.throwConsoleError(err);
          }
        },
      });
  }

  exportIndustrial(): void {
    const exportDate = this.exportDate || new Date().toISOString().slice(0, 10);
    this._exportacaoService
      .downloadExport(this.userId, this.industrial, this.clientTypeID)
      .subscribe({
        next: (response: Blob) => {
          saveAs(response, `RelatorioObras_${exportDate}.xlsx`);
        },

        error: (err) => {
          console.error('Erro ao baixar o arquivo:', err);

          if (err.status === 400) {
            if (err.error instanceof Blob) {
              err.error
                .text()
                .then((text: string) => {
                  try {
                    const errorMessages = JSON.parse(text);
                    if (
                      Array.isArray(errorMessages) &&
                      errorMessages.length > 0
                    ) {
                      alert(errorMessages[0]);
                    } else {
                      alert('Erro desconhecido.');
                    }
                  } catch (e) {
                    console.error('Erro ao processar a resposta JSON:', e);
                    alert('Erro ao processar a resposta.');
                  }
                })
                .catch((e) => {
                  console.error('Erro ao ler o Blob:', e);
                  alert('Erro ao processar a resposta do servidor.');
                });
            }
          } else {
            this._errorHandleService.throwConsoleError(err);
          }
        },
      });
  }

  dadosExportacaoIndustrial() {
    this.subscriptions.add(
      this._exportacaoService
        .infoExportacao(this.industrial, this.clientTypeID)
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.exportacaoIndustrial = response.data;
            } else {
              this._errorHandleService.throwConsoleError(response);
            }
          },
        }),
    );
  }
}
